import { useState } from 'react';
import { Button } from '../../components/Button';
import { Logo } from '../../components/Logo';
import { PasswordField } from '../../components/PasswordField';
import { TextField } from '../../components/TextField';
import { Credentials } from '../../services/authentication';
import styles from './Login.module.css';
import { clickLogo, setCredentials, useLogin, useQAMenu } from './useLogin';
import { FormattedMessage } from 'react-intl';
import { DelayUnmount } from '../../components/DelayUnmount';
import { EnvModal } from '../../components/EnvModal';
import { SYSTEM_ENV } from '../../constants.ts';

const FORGOT_PASSWORD_URL =
  SYSTEM_ENV === 'prod'
    ? 'https://id.ruptela.com/forgotten-password'
    : SYSTEM_ENV === 'prep'
    ? 'https://id-prep.ruptela.com/forgotten-password'
    : 'https://id-test.ruptela.com/forgotten-password';

export const Login = () => {
  const [form, setForm] = useState<Credentials>({
    username: '',
    password: '',
  });

  const qaMenu = useQAMenu();

  const { running, error } = useLogin();

  const setFieldValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((form) => ({ ...form, [name]: value }));
  };

  return (
    <div className={styles.login}>
      <div>
        <header className={styles.header}>
          <div onClick={clickLogo} className={styles.logo} title="Journey App">
            <Logo />
            {SYSTEM_ENV !== 'prod' && <div className={styles.env}>{SYSTEM_ENV}</div>}
          </div>
          <div className={styles.heading}>
            <FormattedMessage id="Welcome" />
          </div>
        </header>
        <main>
          <form
            className={styles.form}
            onSubmit={(e) => {
              e.preventDefault();
              setCredentials(form);
            }}
            noValidate
          >
            <TextField
              label={<FormattedMessage id="Email" />}
              name="username"
              value={form.username}
              error={
                error?.username && <FormattedMessage id={error?.username} />
              }
              onChange={setFieldValue}
              disabled={running}
              type="email"
            />
            <PasswordField
              name="password"
              label={<FormattedMessage id="Password" />}
              value={form.password}
              error={
                error?.password && <FormattedMessage id={error?.password} />
              }
              onChange={setFieldValue}
              disabled={running}
            />
            <Button className={styles.btn} disabled={running} type="submit">
              <FormattedMessage id="Login" />
            </Button>
            <Button
              as="a"
              variant="text"
              href={FORGOT_PASSWORD_URL}
              target="_blank"
            >
              <FormattedMessage id="Password.Forgot" />
            </Button>
          </form>
        </main>
      </div>
      <DelayUnmount unmount={!qaMenu}>
        <EnvModal />
      </DelayUnmount>
    </div>
  );
};
